module.exports = __webpack_public_path__ + "media/images/favicon/primary/ms-icon-310x310-12a85a953b50bf4e226ffdb1c1aee9ab.png";